// Badge unlock check trigger — completion flows call this after a successful
// trip/activity completion or photo upload. The server awards badges in a
// deferred task right after the completion response, so the check waits a
// beat before polling the unnotified-badges endpoint.
//
// BadgeUnlockCelebration (mounted once in App) listens for this event, shows
// the full-screen unlock moment, and marks badges notified on dismiss.

export const BADGE_UNLOCK_CHECK_EVENT = 'lyf:check-badge-unlocks';

export function requestBadgeUnlockCheck(delayMs = 1200) {
  setTimeout(() => {
    window.dispatchEvent(new CustomEvent(BADGE_UNLOCK_CHECK_EVENT));
  }, delayMs);
}
